<template>
  <div>
    <div class="text-left mb-1">
      <span class="headline" id="headerlist">Product List</span>
    </div>
    <!-- Table Start -->
    <div class="holder">
      <div class="filter">
        <v-text-field
          v-model="filter"
          v-on:keyup="filterList"
          label="search by product name"
          append-icon="mdi-filter"
        />
      </div>
      <div class="paginate">
        <v-select
          v-model="paginationcount"
          v-on:change="paginateList"
          :items="paginationcounts"
          item-text="name"
          item-value="name"
          :selected="paginationcounts.value === 10"
          label="show by"
        ></v-select>
      </div>
    </div>
    <v-row align-content="end">
      <v-col :cols="12" align-self="end">
        <v-spacer></v-spacer>
        <v-text-field
          label="Rate/Gram"
          dense
          outlined
          append-outer-icon="mdi-content-save"
          v-model="rate_gram"
          @click:append-outer="updateAllRateGram"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-simple-table fixed-header fixed-footer height="450px" class="elevation-2">
      <template v-slot:default>
        <thead>
          <tr class="tableheader">
            <th class="text-left">Item Number</th>
            <th class="text-left">Name</th>
            <th class="text-left">Price</th>
            <th class="text-left">Supplier</th>
            <th class="text-left">Supplier Code</th>
            <th class="text-left">Product Type</th>
            <th class="text-left">Karat</th>
            <th class="text-left">Item Weight</th>
            <th class="text-left">Rate/Gram</th>
            <th class="text-left">Measurement</th>
            <th class="text-left">Classification of Gold</th>
            <th class="text-left">No. Of Diamonds</th>
            <th class="text-left">In stock</th>
            <th class="text-left">Sold</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in products" :key="item.id" @click="showProduct(item.id)">
            <td class="text-left">{{ (page - 1) * paginationcount + index + 1 }}</td>
            <td class="text-left">{{ item.name }}</td>
            <td class="text-left">{{ parseFloat(item.price).toLocaleString() }}</td>
            <td class="text-left">
              {{ item.supplier_id == null ? '' : item.supplier.company_name }}
            </td>
            <td class="text-left">
              {{ item.supplier_id == null ? '' : item.supplier.supplier_code }}
            </td>
            <!--<td class="text-left">{{ item.product_type.name }}</td>-->
            <td class="text-left">
              {{ item.product_type_id == null ? '' : item.product_type.name }}
            </td>
            <td class="text-left">{{ item.karat }}</td>
            <td class="text-left">{{ item.item_weight }}</td>
            <td class="text-left">{{ item.rate_gram }}</td>
            <td class="text-left">{{ item.measurement }}</td>
            <td class="text-left">{{ item.gold_classification }}</td>
            <td class="text-left">{{ item.no_of_diamond }}</td>
            <td class="text-left">{{ parseFloat(item.stock).toLocaleString() }}</td>
            <td class="text-left">{{ parseFloat(item.sold).toLocaleString() }}</td>
          </tr>
          <tr v-if="pagination.meta.total == 0">
            <td colspan="14" style="height:400px; text-align: center;">
              No records found
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="pt-2">
      <v-pagination
        v-if="pagination.meta.total > 0"
        align="right"
        v-model="page"
        :length="pagination.meta.last_page"
        circle
      ></v-pagination>
    </div>
    <!-- Table End -->
    <!-- Create Start -->
    <v-btn
      fixed
      bottom
      right
      @click="$router.push('/product/create')"
      color="blue darken-2"
      dark
      fab
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <productCreate
      v-if="create"
      :page="page"
      :create="create"
      @createChange="
        value => {
          this.create = value;
        }
      "
    />
    <productEdit v-if="edit" :page="page" :edit="edit" />
    <productShow v-if="show" :show="show" :page="page" :inventory="inventory" />
    <confirm ref="confirm"></confirm>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import productCreate from './ProductCreate';
import productShow from './ProductShow';
import productEdit from './ProductEdit';
import confirm from '../../components/Confirm.vue';

export default {
  data: function() {
    return {
      page: 1,
      filter: '',
      paginationcount: '10',
      rate_gram: 0
    };
  },
  components: {
    productCreate,
    productShow,
    productEdit,
    confirm
  },
  props: {
    create: false,
    show: false,
    edit: false,
    inventory: true
  },
  watch: {
    page(val) {
      this['Product/fetchProducts']({
        page: val,
        filter: this.filter,
        paginationcount: this.paginationcount
      });
    },
    $route(to, from) {
      if (this.show) {
        this['Product/getProduct']({ id: to.params.id });
      }
    }
  },
  computed: {
    ...mapState({
      products: state => state.Product.products.data,
      paginationcounts: state => state.Unit.paginationcount,
      pagination: state => {
        if (state.Product.products.length === 0) {
          return {
            meta: {
              last_page: 0
            }
          };
        }
        return state.Product.products;
      }
    })
  },
  mounted() {
    this['Product/fetchProducts']({ page: this.page, paginationcount: this.paginationcount });
  },
  methods: {
    ...mapActions(['Product/fetchProducts', 'Product/getProduct']),
    showProduct(id) {
      this.$router.push(`/product/${id}`);
    },
    filterList() {
      if (this.page !== 1) this.page = 1;
      else
        this['Product/fetchProducts']({
          page: this.page,
          filter: this.filter,
          paginationcount: this.paginationcount
        });
    },
    paginateList() {
      if (this.page !== 1) this.page = 1;
      else this['Product/fetchProducts']({ page: 1, paginationcount: this.paginationcount });
    },
    updateAllRateGram() {
      this.$refs.confirm
        .open(
          'Update Rate/Gram',
          'Are you sure you want update Rate and Gram of the current list?',
          { color: '#f44336' }
        )
        .then(confirm => {
          const data = {
            rate_gram: this.rate_gram
          };

          this.products.forEach(function(product) {
            axios
              .post(`api/v1/product/${[product.id]}/updateProductRateGram`, data)
              .then(response => {})
              .catch(error => {})
              .finally(() => {});
          });

          this.$store.commit('SET_SNACK_BAR', {
            message: 'Product saved...',
            color: 'success'
          });

          this.filterList();
        });
    }
  }
};
</script>
